import { render, staticRenderFns } from "./PendingProfilesView.vue?vue&type=template&id=1fa61f26&scoped=true&"
import script from "./PendingProfilesView.vue?vue&type=script&lang=ts&"
export * from "./PendingProfilesView.vue?vue&type=script&lang=ts&"
import style0 from "./PendingProfilesView.vue?vue&type=style&index=0&id=1fa61f26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa61f26",
  null
  
)

export default component.exports